import React from 'react'
import { BANKING_BOTTOM_CONTENT, CYBER_COURSE_PAGE_1, CYBER_DETAILS_PAGE_1, CYBER_HERO_PAGE_1 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { CYBER_ACCORDIAN_1 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'


const CyberPage_1 = () => {
  return (
    <div className='outlet-render'>
     <CourseAsideHero  {...CYBER_HERO_PAGE_1}/>
      <CoursesAside {...CYBER_COURSE_PAGE_1}/>
      <CourseCard {...CYBER_DETAILS_PAGE_1}/>
      <Accordian {...CYBER_ACCORDIAN_1}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default CyberPage_1